import { useContext } from 'react';
import { AppTourContext } from './AppTourContext';

export function useAppTour() {
  const context = useContext(AppTourContext);
  if (!context) {
    throw new Error('useAppTour must be used within AppTourProvider');
  }
  return context;
}

export function useAppTourOptional() {
  return useContext(AppTourContext);
}
